<template>
  <div class="bg-gray-50 flex flex-col justify-center py-8 sm:px-6 lg:px-8">
    <div class="sm:mx-auto sm:w-full sm:max-w-xl">
      <div class="bg-white py-6 px-4 shadow-xl sm:rounded-lg sm:px-8">
        <div>
          <h2 class="text-center auth-title">
            Créer un compte
          </h2>
        </div>

        <form class="mt-8 space-y-6" @submit.prevent="handleSubmit">
          <div class="rounded-md shadow-sm -space-y-px">
            <div>
              <label for="firstname" class="sr-only">Prénom</label>
              <input
                id="firstname"
                v-model="form.firstname"
                type="text"
                required
                class="auth-input"
                placeholder="Prénom"
              />
            </div>
            <div>
              <label for="lastname" class="sr-only">Nom</label>
              <input
                id="lastname"
                v-model="form.lastname"
                type="text"
                required
                class="auth-input"
                placeholder="Nom"
              />
            </div>
            <div>
              <label for="email" class="sr-only">Email</label>
              <input
                id="email"
                v-model="form.email"
                type="email"
                required
                class="auth-input"
                placeholder="Email"
              />
            </div>
            <div>
              <label for="password" class="sr-only">Mot de passe</label>
              <input
                id="password"
                v-model="form.password"
                type="password"
                required
                class="auth-input"
                placeholder="Mot de passe"
              />
            </div>
          </div>

          <div>
            <button
              type="submit"
              :disabled="loading"
              class="auth-button"
            >
              <span v-if="loading">Inscription en cours...</span>
              <span v-else>S'inscrire</span>
            </button>
          </div>

          <div v-if="error" class="mt-2 text-red-600 text-sm text-center">
            {{ error }}
          </div>

          <div class="text-sm text-center">
            <router-link
              to="/login"
              class="font-medium text-indigo-600 hover:text-indigo-500"
            >
              Déjà inscrit ? Se connecter
            </router-link>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive } from 'vue'
import { useRouter } from 'vue-router'
import { useAuthStore } from '@/stores/auth.store'

const router = useRouter()
const authStore = useAuthStore()

const form = reactive({
  firstname: '',
  lastname: '',
  email: '',
  password: ''
})

const loading = ref(false)
const error = ref('')

const handleSubmit = async () => {
  loading.value = true
  error.value = ''
  
  try {
    await authStore.register(form)
    router.push('/login?registered=true')
  } catch (err) {
    error.value = err.response?.data?.message || 'Une erreur est survenue'
  } finally {
    loading.value = false
  }
}
</script> 